<template>
  <component
    :is="step.ctaPath ? 'a' : 'div'"
    class="qs-step-row"
    :class="{ 'qs-step-row--completed': step.completed }"
    :href="step.ctaPath"
    :data-testid="`quick-start-step-${step.key}`"
    @click="handleClick"
  >
    <i
      v-if="step.completed"
      class="hi hi-check-circle-filled qs-step-row__icon qs-step-row__icon--completed"
      data-testid="quick-start-step-checkmark"
    />
    <span
      v-else
      class="qs-step-row__index"
      data-testid="quick-start-step-index"
    >{{ index }}</span>

    <span
      class="qs-step-row__title"
      :class="{ 'qs-step-row__title--completed': step.completed }"
    >{{ step.title }}</span>

    <i
      v-if="!step.completed && step.ctaPath"
      class="hi hi-right-arrow-heavy qs-step-row__arrow"
      data-testid="quick-start-step-cta-arrow"
    />
  </component>
</template>

<script>
import { QuickStartResource } from '~/resources';

export default {
  name: 'QuickStartStepRow',
  props: {
    step: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    async handleClick(event) {
      if (!this.step.ctaPath) {
        return;
      }

      event.preventDefault();

      try {
        await QuickStartResource.recordStepProgress(
          { organizationId: this.organizationId },
          { step: this.step.key, section: this.sectionName, completed: this.step.completed },
        );
      } finally {
        window.location.href = this.step.ctaPath;
      }
    },
  },
};
</script>
